import { render, staticRenderFns } from "./CNamePopup.vue?vue&type=template&id=1134fd06&scoped=true&"
import script from "./CNamePopup.vue?vue&type=script&lang=js&"
export * from "./CNamePopup.vue?vue&type=script&lang=js&"
import style0 from "./CNamePopup.vue?vue&type=style&index=0&id=1134fd06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1134fd06",
  null
  
)

export default component.exports